import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesRoutingModule } from './pages-routing.module';
import { RanklistPageComponent } from './ranklist/ranklist-page.component';
import { RanklistComponent } from './ranklist/presentational-component/ranklist.component';
import { BranchChampionsPageComponent } from './branchchampions/branchchampions-page.component';
import { BranchChampionsComponent } from './branchchampions/presentational-component/branchchampions.component';
import { RoomChampionsPageComponent } from './roomchampions/roomchampions-page.component';
import { RoomchampionsComponent } from './roomchampions/presentational-component/roomchampions.component';
import { LastplayersPagesComponent } from './lastplayers/lastplayers-pages.component';
import { LastplayersComponent } from './lastplayers/presentational-component/lastplayers.component';
import { ChampionTvPageComponent } from './championtv/championtv-page.component';
import { ChampionTvComponent } from './championtv/presentational-component/championtv.component';
import { NbCardModule, NbSelectModule, NbSpinnerModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeModule } from '../@theme/theme.module';
import { ResponsiveranklistPageComponent } from './responsiveranklist/responsiveranklist-page.component';
import { ResponsiveranklistComponent } from './responsiveranklist/presentational-component/responsiveranklist.component';
import { ResponsiveRoomChampionsPageComponent } from './responsiveroomchampions/responsiveroomchampions-page.component';
import { ResponsiveRoomchampionsComponent } from './responsiveroomchampions/presentational-component/responsiveroomchampions.component';

@NgModule({
  declarations: [
    RanklistPageComponent,
    RanklistComponent,
    BranchChampionsPageComponent,
    BranchChampionsComponent,
    RoomChampionsPageComponent,
    RoomchampionsComponent,
    LastplayersPagesComponent,
    LastplayersComponent,
    ChampionTvPageComponent,
    ChampionTvComponent,
    ResponsiveranklistPageComponent,
    ResponsiveranklistComponent,
    ResponsiveRoomChampionsPageComponent,
    ResponsiveRoomchampionsComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    NbCardModule,
    NbSpinnerModule,
    FormsModule,
    NbSelectModule,
    ThemeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PagesModule {}
